export default (params) => {
  const { preTag } = params;

  return {
    nodes: [
      {
        match: [
          {
            type: `${preTag}_organization_details`,
            min: 1,
            max: 1,
          },
          {
            type: `${preTag}_title`,
            min: 1,
          },
        ],
      },
    ],
  };
};
